<template>
  <FormSection :name="$t('orderDetail.rumsInfo.title')" v-if="isBilledCompany">
    <Fragment v-if="invoice && invoice.status === 'invoiced'">
      <StaticInfo
        :name="$t('orderDetail.rumsInfo.orderDate')"
        :value="formattedDate(invoice.date)"
        data-testid="order-form__invoice-date"
      />
      <StaticInfo
        :name="$t('orderDetail.rumsInfo.orderNumber')"
        :value="invoice.number"
        data-testid="order-form__invoice-number"
      />
      <StaticInfo
        :name="$t('orderDetail.rumsInfo.calculatedCosts')"
        :value="euro(invoice.costs)"
        data-testid="order-form__invoice-costs"
      />
    </Fragment>

    <Fragment v-else-if="!isBilledOrderType">
      {{ $t('orderDetail.orderTypeNotInvoiced') }}
    </Fragment>

    <Fragment v-else-if="!invoice">
      {{ $t('orderDetail.notYetInvoiced') }}
    </Fragment>

    <Fragment v-else>
      {{ $t('orderDetail.isSentToRUMS') }}
    </Fragment>
  </FormSection>
</template>

<script>
import { Fragment } from 'vue-fragment'

import StaticInfo from '@/components/Form/StaticInfo/index.vue'
import dateUtils from '@/components/mixins/dateUtils'
import stringUtils from '@/components/mixins/stringUtils'

import { ORDER_TYPE } from '@/api/orders'

export default {
  name: 'BillingSection',
  components: { StaticInfo, Fragment },
  mixins: [dateUtils, stringUtils],
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    isBilledCompany() {
      return this.order.company?.processable_by_rums
    },
    isBilledOrderType() {
      return this.order.type !== ORDER_TYPE.SWITCHING
    },
    invoice() {
      return this.order.invoice
    },
  },
}
</script>
